import axios from "axios";
import { getApiHeaders } from "../../api/apiHeaders";
//import { I18n } from "react-redux-i18n";
import {
    BALANCE_LIST_ATTEMPT,
    BALANCE_LIST_SUCCESS,
    BALANCE_LIST_FAILED,
    ////////////////////
    BALANCE_MORELIST_ATTEMPT,
    BALANCE_MORELIST_SUCCESS,
    BALANCE_MORELIST_FAILED,
    //////////////////////
    BALANCE_NEW_SUCCESS,
    BALANCE_NEW_FAILED,
} from "../types/balanceTypes";
import { config } from "../../config";

const url_api = config.api.web;

export function loading() {
    return {
        type: BALANCE_LIST_ATTEMPT
    };
}

export function success(data) {
    return {
        type: BALANCE_LIST_SUCCESS,
        data: data
    };
}

export function failed(error) {
    return {
        type: BALANCE_LIST_FAILED,
        error: error
    };
}

///////////////////////////////////////////

export function loadingMore() {
    return {
        type: BALANCE_MORELIST_ATTEMPT
    };
}

export function successMore(data) {
    return {
        type: BALANCE_MORELIST_SUCCESS,
        data: data
    };
}

export function failedMore(error) {
    return {
        type: BALANCE_MORELIST_FAILED,
        error: error
    };
}
//////////////////////////

export function successNew(item) {
    return {
        type: BALANCE_NEW_SUCCESS,
        item: item
    };
}

export function failedNew(error) {
    return {
        type: BALANCE_NEW_FAILED,
        error: error
    };
}
////////////////////////

export const loadList = (data: Object) => async dispatch => {
    dispatch(loading());
    await axios
        .get(url_api + "balance/", {
            params: data.params,//{
            // id: data.user_id,
            //token: data.token,
            //lang: I18n.t("locale")
            // },
            headers: getApiHeaders(),
        })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(success({
                        ...response.data.body,
                        kind: data.params.kind || '',
                        search: data.params.search || '',
                    }));
                else dispatch(failed(response.data.body));
            } else {
                dispatch(failed("try_later"));
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.Error) {
                dispatch(failed("try_later"));
            } else {
                dispatch(failed("try_later"));
            }
            return;
        });
};

export const loadListScroll = (data: Object) => async dispatch => {
    dispatch(loadingMore());
    await axios
        .get(url_api + "balance/", {
            params: data.params,
            headers: getApiHeaders(),
        })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(successMore({
                        ...response.data.body,
                        kind: data.params.kind || '',
                        search: data.params.search || '',
                    }));
                else dispatch(failedMore(response.data.body));
            } else {
                dispatch(failedMore("try_later"));
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.Error) {
                dispatch(failedMore("try_later"));
            } else {
                dispatch(failedMore("try_later"));
            }
            return;
        });
};


export const newItem = (data: Object) => async (dispatch) => {
    await axios({
        method: "POST",
        url: url_api + "balance/",
        data: data.params,
        headers: getApiHeaders(),
    })
        .then(function (response) {
            //  console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(successNew(response.data.body));
                else dispatch(failedNew(response.data.body));
            } else {
                dispatch(failedNew("try_later"));
            }
        })
        .catch(function (error) {
            //console.log(error);
            if (error.Error) {
                dispatch(failedNew("try_later"));
            } else {
                dispatch(failedNew("try_later"));
            }
            return;
        });
};